import {
  addProductToWishlist,
  createDefaultWishlist,
  getWishlists,
  removeFromWishlist,
} from "@app/scripts/api/wishlist"
import { selectDefaultWishlist } from "@app/scripts/utils"
import { IWishlistItem } from "@app/types/wishlist"

class WishlistSaveButton extends HTMLElement {
  owner?: string
  productId: string
  variantId: string
  productHandle: string
  button: HTMLButtonElement | null = null
  wishlistId: string | null = null
  wishlistItem: IWishlistItem | null = null

  constructor() {
    super()
    this.productId = this.dataset.productId!
    this.variantId = this.dataset.variantId!
    this.productHandle = this.dataset.productHandle!
    this.owner = window.ShopifyAnalytics.meta.page.customerId?.toString()
    console.assert(!!this.productId, "[wishlist] Product ID is required")
    console.assert(!!this.variantId, "[wishlist] Variant ID is required")
  }

  async connectedCallback() {
    this.button = this.querySelector("button")
    this.button?.addEventListener("click", this.handleButtonClick)

    if (!this.owner) return
    this.handleLoading()
    this.wishlistItem = await this.getWishlistItem()
    this.handleButtonStatus()
    this.handleLoading(false)
  }

  handleButtonClick = async () => {
    if (!this.owner) {
      // User not logged in
      window.location.href =
        "/account/login?return_url=%2Fproducts%2F" + this.productHandle
      return
    }

    this.handleLoading()

    await this.getOrCreateWishlistId()

    if (!this.wishlistId) {
      this.handleLoading(false)
      return
    }

    if (this.wishlistItem) {
      this.handleButtonStatus(false)
      const variantId = String(this.wishlistItem.product.variants[0].id)
      await removeFromWishlist(
        this.wishlistItem.id,
        this.productId,
        variantId,
        this.wishlistId!
      )
      this.wishlistItem = null
    } else {
      this.handleButtonStatus(true)
      await addProductToWishlist({
        owner: this.owner,
        product_id: this.productId,
        variant_id: this.variantId,
        wishlist_ids: [this.wishlistId],
      })
      this.wishlistItem = await this.getWishlistItem()
    }

    this.handleLoading(false)
  }

  handleButtonStatus = (forceStatus?: boolean) => {
    this?.classList.toggle(
      "is-active",
      forceStatus !== undefined ? forceStatus : !!this.wishlistItem
    )

    if (forceStatus !== undefined) {
      this.handleButtonStatusOnSimilarIcons(forceStatus)
    }
  }

  handleButtonStatusOnSimilarIcons = (status: boolean) => {
    const otherIcons = document.querySelectorAll(
      `wishlist-save-button[data-product-id="${this.productId}"]`
    )
    otherIcons.forEach((icon) => {
      icon.classList.toggle("is-active", status)
    })
  }

  getWishlistItem = async () => {
    const res = await getWishlists(this.owner!)
    const wishlists = res?.wishlists || null
    const wishlist = selectDefaultWishlist(wishlists || [])
    this.wishlistId = wishlist?.id || null
    if (!wishlist) return null
    return (
      wishlist.items.item?.find(
        (item) => String(item.product.id) === String(this.productId)
      ) || null
    )
  }

  handleLoading = (isLoading = true) => {
    this.button?.toggleAttribute("disabled", isLoading)
  }

  getOrCreateWishlistId = async () => {
    if (this.wishlistId) return this.wishlistId
    await createDefaultWishlist(this.owner!)
    return await this.getWishlistItem()
  }
}

customElements.define("wishlist-save-button", WishlistSaveButton)
